import React, { useState, useEffect } from "react";
import banner from "../../assets/images/homebanner.png";
import banner1 from "../../assets/images/dattamandirslide1.png";
import banner2 from "../../assets/images/dattamandirslide2.png";
import middlesectionimage from "../../assets/images/new5.jpg";
import "./OldHome.scss";
import img1 from "../../assets/babajiImages/b1.png";
import img2 from "../../assets/babajiImages/b2.png";
import img3 from "../../assets/babajiImages/b3.png";
import img4 from "../../assets/babajiImages/b4.png";
import img5 from "../../assets/babajiImages/b5.jpg";
import img6 from "../../assets/babajiImages/b6.jpeg";
import img7 from "../../assets/babajiImages/b7.jpg";
import img8 from "../../assets/babajiImages/b8.jpg";
import img9 from "../../assets/babajiImages/b9.jpg";
import flagGif from "../../assets/images/flag.gif";


export default function Home() {
  const images = [img1, img2, img3, img4, img5, img6, img7, img8, img9];
  const [startIndex, setStartIndex] = useState(0);
  const [isSliding, setIsSliding] = useState(false);
  const [mobilestartIndex, mobilesetStartIndex] = useState(0);
  const [mobileisSliding, mobilesetIsSliding] = useState(false);


  // Function to go to the next slide
  const nextSlide = () => {
    setIsSliding(true);
    setTimeout(() => {
      setStartIndex((prevIndex) => (prevIndex + 3 < images.length ? prevIndex + 3 : 0));
      setIsSliding(false);
    }, 500);
  };

  const slidesData = [
    {
      img: banner,
    },
    {
      img: banner1,
    },
    {
      img: banner2,
    }
  ];


  // Function to go to the previous slide
  const prevSlide = () => {
    setIsSliding(true);
    setTimeout(() => {
      setStartIndex((prevIndex) => (prevIndex - 4 >= 0 ? prevIndex - 4 : images.length - 4));
      setIsSliding(false);
    }, 500);
  };

  const mobilenextSlide = () => {
    mobilesetIsSliding(true);
    setTimeout(() => {
      mobilesetStartIndex((prevIndex) => (prevIndex + 1 < images.length ? prevIndex + 1 : 0));
      mobilesetIsSliding(false);
    }, 500);
  };
  const mobileprevSlide = () => {
    mobilesetIsSliding(true);
    setTimeout(() => {
      mobilesetStartIndex((prevIndex) => (prevIndex - 2 >= 0 ? prevIndex - 2 : images.length - 2));
      mobilesetIsSliding(false);
    }, 500);
  };
  // Auto-slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(nextSlide, 5000);
    return () => clearInterval(interval);
  }, [startIndex]);  // Restart interval when `startIndex` changes

  const [currentSlide, setCurrentSlide] = useState(0);

  const handleManualNav = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prevIndex) => (prevIndex + 1) % slidesData.length);
    }, 3000); // Change slide every 3 seconds
    return () => clearInterval(interval); // Clear interval when component unmounts
  }, []);



  return (
    <div>
      {/* <div className="homebanner" style={{ marginTop: "80px" }}> */}
      <div className="homebanner">
        <div className="img-slider">
          {slidesData.map((slide, index) => (
            <div
              className={`slide ${currentSlide === index ? "active" : ""}`}
              key={index}
            >
              <img src={slide.img} alt={slide.title} />
              {/* <div className="info">
                <h2>{slide.title}</h2>
                <p>{slide.description}</p>
              </div> */}
            </div>
          ))}

          <div className="navigation">
            {slidesData.map((_, index) => (
              <div
                className={`btn ${currentSlide === index ? "active" : ""}`}
                key={index}
                onClick={() => handleManualNav(index)}
              ></div>
            ))}
          </div>
        </div>
        {/* <img src={banner} style={{ width: "100%" }}></img>*/}
      </div>
      <div
        className="homebanner2"

      >
        <div className="imagesection">
          <img src={flagGif} alt="Flag" className="flag-gif" />
          <img src={middlesectionimage} alt="Middle Section" />
        </div>

        <div
          className="rightsectiontext"

        >
          <div className="card1text">
            <div className="subtext">
              <p>
                <span style={{ fontSize: "30px", fontWeight: "bold" }}>
                  श्री दत्त मंदिर संस्थान रुईभर
                </span>{" "}
                हे धाराशिव (उस्मानाबाद) पासून १५ कि. मी. अंतरावरील एक छोटेशे पण
                टुमदार गाव. प. पु. सद्गुरू आप्पा बाबांचे रुईभर हे छोटेसे गाव आज
                संपूर्ण महाराष्ट्रातील दत्त उपसकांचे आशेचे, श्रद्धेचे
                केंद्रबिंदू बनलेले आहे. श्रीक्षेत्र रुईभर येथे दत्तमंदिर संस्थान
                या नावाने न्यास नोंदणीकृत असून आज पुज्यश्री या ठीकाणावर १९८३
                पासून आहेत. या ठिकाणातून समाजातील अठरापगड जाती व सर्वधर्मातील
                लोकांना तरुण पिढीला धर्मकार्याची, राष्ट्रकार्याची व समाजसेवेची
                शिकवण महाराज देत आहेत. आठवडाभर समाज प्रबोधनाच्या कार्यात
                पुज्यश्री भारतभर कोठेही असले तरीही प्रत्येक गुरुवारी श्री
                अप्पाबाबा श्री रुईभर येथील श्री दत्तमंदिर संस्थानात असतात.
                निरनिराळ्या ठिकाणाहून भाविक मोठ्या संख्येनेरूईभर येथील मंदिर व
                परमपूज्य महाराजांचे दर्शनास येतात. दत्तमहाराजांना साकडे घालतात
                व् महाराजांकडून आशीर्वाद घेऊन समाधानाने स्वगृही परततात. अनेकांना
                लाभ झाल्याचे भक्तगण एकमेकास श्रद्धेने सांगतात. श्री दत्त
                महाराजांचे कृपेने व परंमपूज्य महाराजांचे प्रेरणेने श्रीक्षेत्र
                रुईभर येथे दत्तमहाराजांचं एक अतिभव्य मंदिर साकारत आहे. त्यातील
                बांधकाम काळ्या पाषाणातील असून त्यावर अत्यंत सुबक व उठावदार
                नक्षीकाम करण्यात येत आहे. या मंदिरात मुख्यत्वेकरून खालील
                गोष्टींचा समावेश असेल. १) भव्य सभागृह १०५×७० चौरसफुट २) गाभारा
                (गर्भगृह) ५ ×५ मीटर्स ३) प्रदक्षिणा मार्ग ४५×५० चौरस फूट. ४)
                गर्भगृहावरील शिखर राजस्थानातील डोळपुरी लाल दगडात केलेले आहे.
                शिखरांची उंची ५१ फूट असून सर्व योजना एक देखण्या मंदिराकडे
                नेण्याचा प्रयत्न आहे. सदर सर्व बांधकाम व विकास कामे भक्तगणकडून
                स्वेच्छेने आलेल्या देणग्यातून होते. ज्याठिकाणी श्रीगुरूंची
                कृपाद्रीष्टी आहे तेथे कमी काय पडणार? या मंदिर परिसरात भाविकांना
                जप, तप, साधना पारायण, ध्यानधारणा करण्यासाठी २७×९ चौरस फुटाचे
                ध्यानमंदिर आहे. याच मंदिर परिसरात १६०×५५ मोठ्या सभागृहाचे काम
                मोठ्या प्रमाणावर प्रगतीपथावर आहे. याच ठिकाणी ५५×६० असे भक्तनिवास
                ही आकार घेत आहे. या ठिकाणी येणाऱ्या व राहणाऱ्या भावकांच्या सर्व
                सोयी व सुविधांचा विचार केला जात आहे. हे भक्त निवास ५ माजली असून
                सर्व सुखसोयींनी युक्त असेल. दत्त भक्तांनी एकदा तरी या पवित्र
                स्थळी दर्शनास जावे श्रींचे आशीर्वाद घ्यावे. सद्गुरू अप्पा बाबाचे
                दर्शन घेऊन कृतकृत्य व्हावे !
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container2">
        <div className="firstsectioncontainer2">
          <h2>Photo Gallery</h2>
          <img src={"https://srikanipakadevasthanam.org/static/media/SD-divider.7a715d6c.svg"} alt="divider" />
        </div>

        {/* Image Gallery Section */}
        <div className="gallery-container">
          <button className="arrow left" onClick={prevSlide}>&#10094;</button>

          <div className={`image-grid ${isSliding ? "slide" : ""}`}>
            {images.slice(startIndex, startIndex + 3).map((image, index) => (
              <div key={index} className="image-card">
                <img src={image} alt={`Gallery Image ${index + 1}`} />
              </div>
            ))}
          </div>

          <button className="arrow right" onClick={nextSlide}>&#10095;</button>
        </div>
        {/* <div className="viewallphoto">
            <button className="viewallphotobutton">View All Photos</button>
            </div> */}
      </div>
      <div className="mobile-container2">
        <div className="firstsectioncontainer2">
          <h2>Photo Gallery</h2>
          <img src={"https://srikanipakadevasthanam.org/static/media/SD-divider.7a715d6c.svg"} alt="divider" />
        </div>

        {/* Image Gallery Section */}
        <div className="gallery-container">
          <button className="arrow left" onClick={mobileprevSlide}>&#10094;</button>

          <div className={`image-grid ${mobileisSliding ? "slide" : ""}`}>
            {images.slice(mobilestartIndex, mobilestartIndex + 1).map((image, index) => (
              <div key={index} className="image-card">
                <img src={image} alt={`Gallery Image ${index + 1}`} />
              </div>
            ))}
          </div>

          <button className="arrow right" onClick={mobilenextSlide}>&#10095;</button>
        </div>
        {/* <div className="viewallphoto">
            <button className="viewallphotobutton">View All Photos</button>
            </div> */}
      </div>
    </div>
  );
}
